import { useQuery } from '@tanstack/react-query';
import apiFetch from '../../utils/apiFetch';
import { authHeaders } from './helpers';
import type { Employee } from './types';

export function useEmployees() {
  return useQuery<Employee[], Error>({
    queryKey: ['employees'],
    queryFn: async () => {
      const res = await apiFetch('/api/v1/payroll/employees', { headers: authHeaders() });
      if (!res.ok) {
        if (res.status === 401) throw new Error('Invalid or expired token. Please log in again.');
        throw new Error('Could not load employees.');
      }
      const data = await res.json();
      const list: Employee[] = Array.isArray(data) ? data : (data.items || data.employees || []);
      return list;
    },
    refetchOnWindowFocus: false,
  });
}